const initialState = {
    gamesList: '',
    upcomingEvents: '',
    draws: '',
    endings: '',
    noResults: false,
    participated: true,
    timeRemaining: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'UPCOMING_EVENTS':
            return { ...state, upcomingEvents: action.payload }
        case 'GAMES_LIST':
            return { ...state, gamesList: action.payload }
        case 'NO_RESULTS':
            return { ...state, noResults: action.payload }
        case 'PARTICIPATED':
            return { ...state, participated: action.payload }
        case 'DRAWS':
            return { ...state, draws: action.payload }
        case 'ENDINGS':
            return { ...state, endings: action.payload }
        case 'SET TIME REMAINING':
            return { ...state, timeRemaining: action.payload }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/eventsReducer.js